import { Spinner as ChakraSpinner } from '@chakra-ui/react';
import { ThemeLoaderProps } from '@melio/penny';

export const Spinner: React.VFC<ThemeLoaderProps> = ({ color }) => (
  <ChakraSpinner color={color} width="16px" height="16px" thickness="3px" speed="1.3s" />
);
